<template>
  <el-dialog title="确认取消" :visible.sync="partSureShow" width="30%">
    <el-alert :closable="false" type="error">
      <div slot="title" style="font-size: 16px;color: red; text-align: left;">该批次已操作部分移库，重新生成批次，请确认是否打印新批次？</div>
    </el-alert>
    <div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="pkgCode" label="批次"></el-table-column>
        <el-table-column prop="transferAmount" label="批次数量"></el-table-column>
        <el-table-column prop="moveNum" label="操作">
          <template slot-scope="scope">
            <a href="javascript:;" @click="printTransfer(scope.row)">打印</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="ok">
        确认取消
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import { transferPkgSpilt } from "@/apis/inHouse"
export default {
  data() {
    return { partSureShow: false, tableData: [], origin: {} }
  },
  props: {
  },
  components: {
  },
  methods: {
    // 打印
    printTransfer(data) {
      this.$wmsPrint.print().templatePrintByPkg([{ ...data }])
    },
    showCancelPart(data) {
      this.tableData = data.list;
      this.partSureShow = true
      this.origin = data.originData;
    },
    cancel() {
      this.partSureShow = false
    },
    // 确定点击
    async ok() {
      this.$emit('ok', this.origin)
      this.partSureShow = false
    }
  }
}
</script>

<style scoped>
.tips {
  text-align: left;
}
</style>